import axios from "axios";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import './css/reset.css';
import VueCopy from 'v-copy';
Vue.use(VueCopy);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;

axios.defaults.baseURL = "https://pay.cgmmedical.jp/erp_sync"
// axios.defaults.baseURL = "http://localhost:8098/erp_sync"
Vue.prototype.axios = axios;

Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
